import {
  GET_DRIVER_REQUEST,
  GET_DRIVER_ERROR,
  GET_DRIVER_SUCCESS,
  CREATE_DRIVER_REQUEST,
  CREATE_DRIVER_ERROR,
  CREATE_DRIVER_SUCCESS,
  UPDATE_DRIVER_REQUEST,
  UPDATE_DRIVER_ERROR,
  UPDATE_DRIVER_SUCCESS,
  DELETE_DRIVER_REQUEST,
  DELETE_DRIVER_ERROR,
  DELETE_DRIVER_SUCCESS,
  SET_DATA_IS_OBJECT
} from "../../actions/types";
import reducers from "../common"

const initialState = {};
export default (state = initialState, action) => {

  reducers.init(reducers);

  reducers.GET_ENTITY_REQUEST = GET_DRIVER_REQUEST;
  reducers.GET_ENTITY_ERROR = GET_DRIVER_ERROR;
  reducers.GET_ENTITY_SUCCESS = GET_DRIVER_SUCCESS;
  reducers.CREATE_ENTITY_REQUEST = CREATE_DRIVER_REQUEST;
  reducers.CREATE_ENTITY_ERROR = CREATE_DRIVER_ERROR;
  reducers.CREATE_ENTITY_SUCCESS = CREATE_DRIVER_SUCCESS;
  reducers.UPDATE_ENTITY_REQUEST = UPDATE_DRIVER_REQUEST;
  reducers.UPDATE_ENTITY_ERROR = UPDATE_DRIVER_ERROR;
  reducers.UPDATE_ENTITY_SUCCESS = UPDATE_DRIVER_SUCCESS;
  reducers.DELETE_ENTITY_REQUEST = DELETE_DRIVER_REQUEST;
  reducers.DELETE_ENTITY_ERROR = DELETE_DRIVER_ERROR;
  reducers.DELETE_ENTITY_SUCCESS = DELETE_DRIVER_SUCCESS;
  reducers.SET_DATA_IS_OBJECT = SET_DATA_IS_OBJECT;
  reducers.entityName = "driver";

  return reducers.entity(reducers)(state, action);
};